/*!
 * @zoom/nws-http-sdk v3.5.18
 * (c) 2025 Xiaoyu Wang
 * Released under the ISC License.
 */
import axios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ERR_401 = 401;
var ERR_METHOD = 30031000;
var ERR_AUTH_SERVICE_UNAVAILABLE = 30031001;
var ERR_MISS_TOKEN = 30031002;
var ERR_TOKEN_FORMAT_UNAVAILABLE = 30031003;
var ERR_TOKEN_EXPIRE_02 = 30031004;
var ERR_NEED_LOGIN = 30010201;
var ERR_TOKEN_EXPIRE = 30010202;
var ERR_TOKEN_REVOKED = 30010203;
var ERR_VERIFY_ZAPPS = 30010204;
var ERR_INVALID_URI = 30010205;
var ERROR_ILLEGAL_CODE = 30021000;
var NEED_CLEAR_ERRORS = [
    ERR_METHOD,
    ERR_TOKEN_EXPIRE,
    ERR_TOKEN_REVOKED,
    ERR_AUTH_SERVICE_UNAVAILABLE,
    ERR_MISS_TOKEN,
    ERR_TOKEN_FORMAT_UNAVAILABLE,
    ERR_TOKEN_EXPIRE_02,
    ERR_VERIFY_ZAPPS,
    ERR_INVALID_URI,
    ERROR_ILLEGAL_CODE
];

var js_cookie = {exports: {}};

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
}(js_cookie));

var jsCookie = js_cookie.exports;

var cookie = jsCookie.withConverter({
    write: function (value) {
        return encodeURIComponent(value);
    },
    read: function (value) {
        return decodeURIComponent(value);
    }
});
var BU_KEY = '_zm_bu';
function loginByCookie() {
    cookie.set(BU_KEY, location.href);
    location.href = '/signin';
}

function responseBefore$1(response) {
    return response;
}
function getTokenResponseError(error) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        var res = error.response;
        if (res &&
            res.status === ERR_401 &&
            res.data.code === ERR_NEED_LOGIN &&
            _this.autoRedirectLogin) {
            return loginByCookie();
        }
        else {
            reject(error);
        }
    });
}

var DEFAULT_EXCHANGE_CODE_URL = '/nws/zr/1.0/core/room/workspace/app/renewal';
var DEFAULT_EXCHANGE_URL = '/nws/auth/1.0/rfs/exchange';
var DEFAULT_REFRESH_URL = '/nws/auth/1.0/rfs/refresh';
var DEFAULT_TOKEN_URL = '/nws/common/1.0/zak';
var DEFAULT_AUTH2_TOKEN_URL = '/nws/common/2.0/nak';
var DEFAULT_TOKEN_KEY$1 = 'zak';
var REFRESH_TOKEN_KEY = 'rfs-zak';
var HEADERS_KEY = 'headers';
var DEFAULT_EXCHANGE_TOKEN_KEY = 'Authorization';
var EXCHANGE_CODE_CONTEXT_KEY = 'x-zoom-app-context';
var DEFAULT_TOKEN_REFRESH_TIME = 55 * 60 * 1000;
var EXCHANGE_CODE_SESSION_KEY = '__nws_code';
var TOKEN_SESSION_KEY = '__nws_token';
var REFRESH_TOKEN_SESSION_KEY = '__nws_rfs_token';
var Config = /** @class */ (function () {
    function Config(options) {
        this.useToken = true;
        this.refreshTokenType = 'self';
        this.supportCache = false;
        this.tokenUrl = DEFAULT_TOKEN_URL;
        this.refreshUrl = DEFAULT_REFRESH_URL;
        this.exchangeUrl = DEFAULT_EXCHANGE_URL;
        this.exchangeCodeUrl = DEFAULT_EXCHANGE_CODE_URL;
        this.exchangeCode = '';
        this.getRefreshToken = null;
        this.exchangeTokenFailed = null;
        this.refreshTokenFailed = null;
        this.getExchangeCode = null;
        this.getExchangeCodeContext = null;
        this.tokenParams = {};
        this.tokenHeaderParams = {};
        this.retryGetToken = false;
        this.needRefreshToken = true;
        this.tokenRefreshTime = DEFAULT_TOKEN_REFRESH_TIME;
        this.tokenReady = function () {
            return;
        };
        this.tokenRemove = function () {
            return;
        };
        this.tokenRefresh = null;
        this.getTokenMethod = 'post';
        this.exchangeTokenMethod = 'post';
        this.exchangeCodeMethod = 'post';
        this.token = '';
        this.refreshToken = '';
        this.tokenRules = [];
        this.exchangeCodeCacheKey = EXCHANGE_CODE_SESSION_KEY;
        this.tokenCacheKey = TOKEN_SESSION_KEY;
        this.refreshTokenCacheKey = REFRESH_TOKEN_SESSION_KEY;
        this.exchangeCodeContextKey = EXCHANGE_CODE_CONTEXT_KEY;
        this.tokenKey = '';
        this.rfsTokenKey = REFRESH_TOKEN_KEY;
        this.requestHeaders = {};
        this.autoRedirectLogin = true;
        this.withBasePms = false;
        this.getTokenWhenCreate = false;
        this.supportShareToken = false;
        Object.assign(this, options);
        this._checkOptions();
    }
    Config.prototype._checkOptions = function () {
        if (!this.tokenKey) {
            this.tokenKey =
                this.refreshTokenType === 'exchangeUrl' ? DEFAULT_EXCHANGE_TOKEN_KEY : DEFAULT_TOKEN_KEY$1;
        }
        if (this.tokenRefresh && typeof this.tokenRefresh !== 'function') {
            throw new Error('tokenRefresh must be a function');
        }
        if (this.tokenReady && typeof this.tokenReady !== 'function') {
            throw new Error('tokenReady must be a function');
        }
        if (this.getRefreshToken && typeof this.getRefreshToken !== 'function') {
            throw new Error('getRefreshToken must be a function');
        }
        if (this.refreshTokenFailed && typeof this.refreshTokenFailed !== 'function') {
            throw new Error('refreshTokenFailed must be a function');
        }
        if (this.exchangeTokenFailed && typeof this.exchangeTokenFailed !== 'function') {
            throw new Error('exchangeTokenFailed must be a function');
        }
    };
    return Config;
}());

function e(e){this.message=e;}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw "Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e;}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";

function tokenPermissionDecode(token) {
    var _a = o(token), st = _a.st, pms = _a.pms;
    if (!st && !pms)
        return [];
    // For 2.0 nak
    if (pms && Array.isArray(pms))
        return pms;
    try {
        var stParse = JSON.parse(st);
        var result_1 = [];
        if (stParse.length) {
            stParse.forEach(function (item) {
                if (item.rl) {
                    result_1.push(item.rl);
                }
                else if (item.action) {
                    result_1 = __spreadArray(__spreadArray([], result_1, true), item.action, true);
                }
            });
        }
        return result_1;
    }
    catch (error) {
        console.log('Token decode failed');
        return [];
    }
}

var AUTH_PREFIX = 'Bearer ';
var REFRESH_TOKEN_TYPE = 'zm_rfs';
var root = (typeof self === 'object' && self.self === self && self) ||
    (typeof global === 'object' && global.global === global && global) ||
    undefined;
function exchangeToken(state) {
    return __awaiter(this, void 0, void 0, function () {
        var getTokenInstance, data, result, token, refreshToken_1, headers, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 10]);
                    state.setState({ requestToken: true });
                    return [4 /*yield*/, handleExchangeTokenCache(state)];
                case 1:
                    if (_a.sent()) {
                        state.setState({ requestToken: false });
                        handlePendingRequest(state);
                        return [2 /*return*/];
                    }
                    getTokenInstance = axios.create();
                    getTokenInstance.interceptors.response.use(responseBefore$1, getTokenResponseError.bind(state));
                    data = void 0;
                    if (!(typeof state.getRefreshToken === 'function')) return [3 /*break*/, 3];
                    return [4 /*yield*/, state.getRefreshToken()];
                case 2:
                    data = _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getTokenInstance.request({
                        url: state.exchangeUrl,
                        method: state.exchangeTokenMethod,
                        params: { code: state.exchangeCode || null },
                        withCredentials: true
                    })];
                case 4:
                    result = _a.sent();
                    data = result.data;
                    _a.label = 5;
                case 5:
                    if (typeof data === 'object') {
                        token = data[DEFAULT_TOKEN_KEY$1];
                        refreshToken_1 = data[REFRESH_TOKEN_KEY];
                        headers = data[HEADERS_KEY] || {};
                        state.setState({
                            retryGetToken: false,
                            token: token,
                            refreshToken: refreshToken_1,
                            requestHeaders: Object.assign({}, state.requestHeaders, headers),
                            tokenRules: tokenPermissionDecode(token)
                        });
                        state.tokenReady({
                            token: state.token,
                            headers: state.requestHeaders,
                            tokenRules: state.tokenRules
                        });
                        cacheExchangeToken(state);
                    }
                    else {
                        return [2 /*return*/, Promise.reject(new Error('Invalid format token'))];
                    }
                    setTokenRefresh(state);
                    handleRetryRequest(state);
                    handlePendingRequest(state);
                    return [3 /*break*/, 10];
                case 6:
                    error_1 = _a.sent();
                    if (!(state.retryGetToken || typeof state.getExchangeCodeContext !== 'function')) return [3 /*break*/, 7];
                    if (state.exchangeTokenFailed && typeof state.exchangeTokenFailed === 'function') {
                        state.exchangeTokenFailed();
                    }
                    handleGetTokenError(error_1, state);
                    return [2 /*return*/, Promise.reject(error_1)];
                case 7:
                    state.setState({ retryGetToken: true });
                    return [4 /*yield*/, generateNewExchangeCode(state)];
                case 8:
                    _a.sent();
                    return [2 /*return*/, exchangeToken(state)];
                case 9: return [3 /*break*/, 10];
                case 10:
                    state.setState({ requestToken: false });
                    return [2 /*return*/];
            }
        });
    });
}
function getToken(state) {
    return __awaiter(this, void 0, void 0, function () {
        var getTokenInstance, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    state.setState({ requestToken: true });
                    getTokenInstance = axios.create();
                    getTokenInstance.interceptors.response.use(responseBefore$1, getTokenResponseError.bind(state));
                    return [4 /*yield*/, getTokenInstance.request({
                            url: state.tokenUrl,
                            method: state.getTokenMethod,
                            headers: state.tokenHeaderParams,
                            params: getParams(state)
                        })];
                case 1:
                    data = (_a.sent()).data;
                    state.setState({ token: data, tokenRules: tokenPermissionDecode(data) });
                    state.tokenReady({ token: state.token, tokenRules: state.tokenRules });
                    setTokenRefresh(state);
                    if (state.tokenRefresh && typeof state.tokenRefresh === 'function') {
                        state.tokenRefresh(null, state.token);
                    }
                    handlePendingRequest(state);
                    handleRetryRequest(state);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    handleGetTokenError(error_2, state);
                    return [2 /*return*/, Promise.reject(error_2)];
                case 3:
                    state.setState({ requestToken: false });
                    return [2 /*return*/];
            }
        });
    });
}
function updateNeedRefreshToken(needRefreshToken, state) {
    var currentState = state || this;
    currentState.setState({ needRefreshToken: needRefreshToken });
    if (currentState.needRefreshToken) {
        refreshToken(currentState);
    }
    else {
        if (currentState.tokenTimer && root)
            root.clearTimeout(currentState.tokenTimer);
    }
}
function removeToken(state) {
    var currentState = state || this;
    currentState.setState({ token: '', tokenRules: [] });
    currentState.tokenRemove();
}
function destroy(state) {
    var currentState = state || this;
    if (currentState.tokenTimer) {
        root && root.clearTimeout(currentState.tokenTimer);
    }
    currentState.setState({ token: '', tokenRules: [], requestHeaders: {} });
    root && root.sessionStorage.removeItem(currentState.exchangeCodeCacheKey);
    root && root.sessionStorage.removeItem(currentState.tokenCacheKey);
    root && root.sessionStorage.removeItem(currentState.refreshTokenCacheKey);
}
function cacheExchangeToken(state) {
    if (state.supportCache && root && root.sessionStorage) {
        root.sessionStorage.setItem(state.exchangeCodeCacheKey, state.exchangeCode);
        root.sessionStorage.setItem(state.tokenCacheKey, state.token);
        root.sessionStorage.setItem(state.refreshTokenCacheKey, state.refreshToken);
    }
}
function clearCache(state) {
    if (root && root.sessionStorage) {
        root.sessionStorage.removeItem(state.exchangeCodeCacheKey);
        root.sessionStorage.removeItem(state.refreshTokenCacheKey);
    }
}
function setTokenRefresh(state) {
    if (state.needRefreshToken && !state.hasStartRefresh) {
        // Get access token expire time
        var exp = o(state.token).exp;
        if (state.tokenRefreshTime === DEFAULT_TOKEN_REFRESH_TIME) {
            // Only set refresh time by token when not set tokenRefreshTime
            state.setState({
                tokenRefreshTime: (exp - Math.floor(Date.now() / 1000) - 3 * 60) * 1000
            });
        }
        refreshToken(state);
        if (state.refreshTokenType === 'exchangeUrl') {
            var typ = o(state.refreshToken.slice(AUTH_PREFIX.length)).typ;
            if (typ !== REFRESH_TOKEN_TYPE) {
                updateNeedRefreshToken(false, state); // Stop token refresh
            }
        }
    }
}
// Control token refresh start/stop
function refreshToken(state) {
    var _this = this;
    state.setState({ hasStartRefresh: true });
    if (state.tokenTimer && root)
        root.clearTimeout(state.tokenTimer);
    state.setState({
        tokenTimer: root &&
            root.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(state.refreshTokenType === 'exchangeUrl')) return [3 /*break*/, 6];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 5]);
                            return [4 /*yield*/, refreshByRefreshToken(state)];
                        case 2:
                            _a.sent();
                            refreshToken(state);
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _a.sent();
                            return [4 /*yield*/, handleRefreshTokenFailed(e_1, state)];
                        case 4:
                            _a.sent();
                            throw new Error('Get token failed');
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            getToken(state)
                                .then(function () {
                                refreshToken(state);
                            })["catch"](function (e) {
                                if (typeof state.refreshTokenFailed === 'function') {
                                    state.refreshTokenFailed(e);
                                }
                                throw new Error('Get token failed');
                            });
                            _a.label = 7;
                        case 7: return [2 /*return*/];
                    }
                });
            }); }, state.tokenRefreshTime > 0 ? state.tokenRefreshTime : DEFAULT_TOKEN_REFRESH_TIME)
    });
}
function refreshByRefreshToken(state) {
    return __awaiter(this, void 0, void 0, function () {
        var data, getTokenInstance, result, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 7]);
                    // Only allow one refresh request
                    state.setState({ refreshingToken: true });
                    getTokenInstance = axios.create();
                    getTokenInstance.interceptors.response.use(responseBefore$1, getTokenResponseError.bind(state));
                    return [4 /*yield*/, getTokenInstance.request({
                            url: state.refreshUrl,
                            method: state.exchangeTokenMethod,
                            headers: (_a = {}, _a[state.rfsTokenKey] = state.refreshToken, _a),
                            withCredentials: true
                        })];
                case 1:
                    result = _b.sent();
                    data = result.data;
                    return [3 /*break*/, 7];
                case 2:
                    error_3 = _b.sent();
                    state.setState({ refreshingToken: false });
                    return [4 /*yield*/, handleRefreshTokenFailed(error_3, state)];
                case 3:
                    if (!_b.sent()) return [3 /*break*/, 5];
                    return [4 /*yield*/, exchangeToken(state)];
                case 4: return [2 /*return*/, _b.sent()];
                case 5:
                    handleGetTokenError(error_3, state);
                    return [2 /*return*/, Promise.reject(error_3)];
                case 6: return [3 /*break*/, 7];
                case 7:
                    state.setState({ token: data, tokenRules: tokenPermissionDecode(data) });
                    state.tokenReady({ token: state.token, tokenRules: state.tokenRules });
                    state.setState({ refreshingToken: false });
                    cacheExchangeToken(state);
                    setTokenRefresh(state);
                    handlePendingRequest(state);
                    handleRetryRequest(state);
                    return [2 /*return*/];
            }
        });
    });
}
function handleRefreshTokenFailed(e, state) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof state.refreshTokenFailed === 'function') {
                        state.refreshTokenFailed(e);
                    }
                    if (!(e && e.response && e.response.data)) return [3 /*break*/, 2];
                    if (!NEED_CLEAR_ERRORS.includes(e.response.data.code)) return [3 /*break*/, 2];
                    if (!(typeof state.getExchangeCodeContext === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, generateNewExchangeCode(state)
                        // clear cache when
                    ];
                case 1:
                    _a.sent();
                    // clear cache when
                    state.supportCache && clearCache(state);
                    return [2 /*return*/, true];
                case 2: return [2 /*return*/, false];
            }
        });
    });
}
function handlePendingRequest(state) {
    if (state.pendingRequest.length) {
        while (state.pendingRequest.length) {
            var _a = state.pendingRequest.shift() || {}, resolve = _a.resolve, config = _a.config;
            if (resolve && config) {
                setTokenHeader(state.tokenKey, state.token, config);
                Object.assign(config.headers, state.requestHeaders);
                resolve(config);
            }
        }
    }
}
function handleRetryRequest(state) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, resolve, reject, config, res, error_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!state.retryRequest.length) return [3 /*break*/, 6];
                    _b.label = 1;
                case 1:
                    if (!state.retryRequest.length) return [3 /*break*/, 6];
                    _a = state.retryRequest.shift() || {}, resolve = _a.resolve, reject = _a.reject, config = _a.config;
                    if (!(resolve && config)) return [3 /*break*/, 5];
                    setTokenHeader(state.tokenKey, state.token, config);
                    Object.assign(config.headers, state.requestHeaders);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, axios.request(config)];
                case 3:
                    res = _b.sent();
                    resolve(res);
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _b.sent();
                    reject && reject(error_4);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function handleGetTokenError(error, state) {
    if (state.pendingRequest.length) {
        while (state.pendingRequest.length) {
            var reject = (state.pendingRequest.shift() || {}).reject;
            reject && reject(error);
            if (!state.pendingRequest.length &&
                state.tokenRefresh &&
                typeof state.tokenRefresh === 'function') {
                state.tokenRefresh(error, state.token);
            }
        }
    }
    if (state.needRefreshToken && state.tokenTimer) {
        root && root.clearTimeout(state.tokenTimer);
    }
    state.setState({ requestToken: false });
}
function handleExchangeTokenCache(state) {
    return __awaiter(this, void 0, void 0, function () {
        var exchangeCode, refreshToken_2, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.supportCache && root && root.sessionStorage)) return [3 /*break*/, 5];
                    exchangeCode = root.sessionStorage.getItem(state.exchangeCodeCacheKey);
                    refreshToken_2 = root.sessionStorage.getItem(state.refreshTokenCacheKey);
                    token = root.sessionStorage.getItem(state.tokenCacheKey);
                    if (!(state.supportShareToken && token && refreshToken_2)) return [3 /*break*/, 1];
                    state.refreshToken = refreshToken_2;
                    state.token = token;
                    return [2 /*return*/, true];
                case 1:
                    if (!(state.exchangeCode === exchangeCode && refreshToken_2)) return [3 /*break*/, 5];
                    state.refreshToken = refreshToken_2;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, refreshByRefreshToken(state)];
                case 3:
                    _a.sent();
                    return [2 /*return*/, true];
                case 4:
                    _a.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/, false];
            }
        });
    });
}
function getParams(_a) {
    var tokenParams = _a.tokenParams, tokenUrl = _a.tokenUrl, withBasePms = _a.withBasePms;
    var result = new URLSearchParams();
    Object &&
        Object.keys(tokenParams).forEach(function (key) {
            if (Array.isArray(tokenParams[key])) {
                var params = tokenParams[key];
                params.forEach(function (value) {
                    result.append(key, value);
                });
            }
            else {
                result.append(key, tokenParams[key]);
            }
        });
    if (withBasePms) {
        if (tokenUrl.includes(DEFAULT_TOKEN_URL)) {
            result.append('permissions', 'User:Base');
        }
        else if (tokenUrl.includes(DEFAULT_AUTH2_TOKEN_URL)) {
            result.append('pms', 'User:Base');
        }
    }
    return result;
}
function generateNewExchangeCode(state) {
    return __awaiter(this, void 0, void 0, function () {
        var exchangeCode, context, res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof state.getExchangeCode === 'function')) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, state.getExchangeCode()];
                case 2:
                    exchangeCode = (_a.sent()).exchangeCode;
                    state.setState({
                        exchangeCode: exchangeCode,
                        token: '',
                        refreshToken: '',
                        tokenRules: []
                    });
                    state.tokenRemove();
                    return [3 /*break*/, 4];
                case 3:
                    _a.sent();
                    throw new Error('Get exchange code failed, custom');
                case 4: return [3 /*break*/, 13];
                case 5:
                    if (!(typeof state.getExchangeCodeContext === 'function')) return [3 /*break*/, 13];
                    context = '';
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, state.getExchangeCodeContext()];
                case 7:
                    res = _a.sent();
                    if (res && res.context) {
                        context = res.context;
                    }
                    return [3 /*break*/, 9];
                case 8:
                    _a.sent();
                    throw new Error('Get context failed');
                case 9:
                    if (!context) {
                        throw new Error('Empty context response');
                    }
                    _a.label = 10;
                case 10:
                    _a.trys.push([10, 12, , 13]);
                    return [4 /*yield*/, getExchangeCodeFromServerByAppContext(state, context)];
                case 11:
                    data = (_a.sent()).data;
                    if (data && data.data) {
                        state.setState({
                            exchangeCode: data.data,
                            token: '',
                            refreshToken: '',
                            tokenRules: []
                        });
                        state.tokenRemove();
                    }
                    return [3 /*break*/, 13];
                case 12:
                    _a.sent();
                    throw new Error('Get exchange code failed, default');
                case 13: return [2 /*return*/];
            }
        });
    });
}
function getExchangeCodeFromServerByAppContext(state, context) {
    return __awaiter(this, void 0, void 0, function () {
        var instance;
        var _a;
        return __generator(this, function (_b) {
            instance = axios.create();
            return [2 /*return*/, instance.request({
                    url: state.exchangeCodeUrl,
                    method: state.exchangeCodeMethod,
                    headers: (_a = {}, _a[state.exchangeCodeContextKey] = context, _a),
                    withCredentials: true
                })];
        });
    });
}

var HttpClient = function (state, axiosOptions) {
    if (axiosOptions === void 0) { axiosOptions = {}; }
    var httpClientInstance = axios.create(axiosOptions);
    httpClientInstance.interceptors.request.use(requestBefore.bind(state), requestError.bind(state));
    httpClientInstance.interceptors.response.use(responseBefore.bind(state), responseError.bind(state));
    httpClientInstance.updateNeedRefreshToken = updateNeedRefreshToken.bind(state);
    httpClientInstance.removeToken = removeToken.bind(state);
    httpClientInstance.destroy = destroy.bind(state);
    httpClientInstance.nwsState = state;
    return httpClientInstance;
};
function requestBefore(config) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        if (_this.useToken && _this.requestToken) {
            _this.pendingRequest.push({ config: config, resolve: resolve, reject: reject });
        }
        else if (_this.useToken && !_this.requestToken && _this.token) {
            setTokenHeader(_this.tokenKey, _this.token, config);
            Object.assign(config.headers, _this.requestHeaders);
            resolve(config);
        }
        else if (_this.useToken && !_this.requestToken && !_this.token) {
            if (_this.refreshTokenType === 'exchangeUrl') {
                exchangeToken(_this)
                    .then(function () {
                    setTokenHeader(_this.tokenKey, _this.token, config);
                    Object.assign(config.headers, _this.requestHeaders);
                    resolve(config);
                })["catch"](function (error) {
                    if (typeof _this.refreshTokenFailed === 'function') {
                        _this.refreshTokenFailed(error);
                    }
                    reject(error);
                    throw error;
                });
            }
            else {
                getToken(_this)
                    .then(function () {
                    setTokenHeader(_this.tokenKey, _this.token, config);
                    Object.assign(config.headers, _this.requestHeaders);
                    resolve(config);
                })["catch"](function (error) {
                    if (typeof _this.refreshTokenFailed === 'function') {
                        _this.refreshTokenFailed(error);
                    }
                    reject(error);
                    throw error;
                });
            }
        }
        else {
            resolve(config);
        }
    });
}
function requestError(error) {
    return Promise.reject(error);
}
function responseBefore(response) {
    return response;
}
function responseError(error) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        var res = error.response;
        if (res && res.status === ERR_401) {
            if (res.data.code === ERR_NEED_LOGIN && _this.autoRedirectLogin) {
                return loginByCookie();
            }
            else if (NEED_CLEAR_ERRORS.includes(res.data.code)) {
                _this.setState({ token: '', tokenRules: [] });
                _this.tokenRemove();
                // Only retry one time
                _this.retryRequest.push({ config: res.config, resolve: resolve, reject: reject });
                if (_this.refreshTokenType === 'exchangeUrl' && _this.refreshToken) {
                    if (!_this.refreshingToken) {
                        refreshByRefreshToken(_this)["catch"](function () {
                            var error = new Error('Get token failed');
                            reject(error);
                            throw error;
                        });
                    }
                }
                else if (_this.refreshTokenType === 'self') {
                    getToken(_this)["catch"](function () {
                        var error = new Error('Get token failed');
                        reject(error);
                        throw error;
                    });
                }
                else {
                    reject(error);
                }
            }
            else {
                _this.setState({ token: '', tokenRules: [] });
                _this.tokenRemove();
                reject(error);
            }
        }
        else {
            reject(error);
        }
    });
}
function setTokenHeader(tokenKey, token, config) {
    if (tokenKey === DEFAULT_EXCHANGE_TOKEN_KEY && !token.includes(AUTH_PREFIX)) {
        (config === null || config === void 0 ? void 0 : config.headers) && (config.headers[tokenKey] = AUTH_PREFIX + token);
    }
    else {
        (config === null || config === void 0 ? void 0 : config.headers) && (config.headers[tokenKey] = token);
    }
}

var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State(options) {
        var _this = _super.call(this, options) || this;
        _this.requestToken = false;
        _this.hasStartRefresh = false;
        _this.refreshingToken = false;
        _this.pendingRequest = [];
        _this.retryRequest = [];
        _this.tokenTimer = null;
        return _this;
    }
    State.prototype.setState = function (params) {
        if (params === void 0) { params = {}; }
        Object.assign(this, params);
    };
    return State;
}(Config));

var DEFAULT_TOKEN_KEY = 'zak';

var nwsHttpClient = {
    create: function (instanceConfig, axiosOptions) {
        var state = new State(instanceConfig);
        if (state.getTokenWhenCreate) {
            var tokenRequest = state.refreshTokenType === 'exchangeUrl' ? exchangeToken : getToken;
            tokenRequest(state)["catch"](function (e) {
                if (typeof state.refreshTokenFailed === 'function') {
                    state.refreshTokenFailed(e);
                }
                throw new Error(e || 'Get token failed');
            });
        }
        return HttpClient(state, axiosOptions);
    }
};

export { DEFAULT_TOKEN_KEY, nwsHttpClient as default };
